import { render, staticRenderFns } from "./Ocr.vue?vue&type=template&id=190d0b73&"
import script from "./Ocr.vue?vue&type=script&lang=js&"
export * from "./Ocr.vue?vue&type=script&lang=js&"
import style0 from "./Ocr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports